import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var Container = function Container(props) {
  return jsx("div", Object.assign({
    className: "cp-container"
  }, props));
};
var CenterPanel = function CenterPanel(_a) {
  var left = _a.left,
    right = _a.right,
    rest = __rest(_a, ["left", "right"]);
  return jsx("div", Object.assign({
    className: "center-panel",
    style: {
      '--left': (left || 0) + "px",
      '--right': (right || 0) + "px"
    }
  }, rest));
};
var PanelContent = function PanelContent(props) {
  return jsx("div", Object.assign({
    className: "cp-panel-content"
  }, props));
};
var LeftPanel = function LeftPanel(_a) {
  var visible = _a.visible,
    panelWidth = _a.panelWidth,
    rest = __rest(_a, ["visible", "panelWidth"]);
  return jsx("div", Object.assign({
    className: classNames('cp-panel', 'cp-left-panel', {
      'cp-left-panel-visible': visible
    }),
    style: {
      '--panel-width': panelWidth + "px"
    }
  }, rest));
};
var RightPanel = function RightPanel(_a) {
  var visible = _a.visible,
    panelWidth = _a.panelWidth,
    rest = __rest(_a, ["visible", "panelWidth"]);
  return jsx("div", Object.assign({
    className: classNames('cp-panel', 'cp-right-panel', {
      'cp-right-panel-visible': visible
    }),
    style: {
      '--panel-width': panelWidth + "px"
    }
  }, rest));
};

export { CenterPanel, Container, LeftPanel, PanelContent, RightPanel };
